import { Lock } from 'lucide-react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  EmptyState,
} from '@wundo/ui';
import { hideDemoUnavailable, useDemoUnavailableOpen } from '@/lib/demoUnavailable.ts';
import { m } from '@/paraglide/messages.js';

/**
 * What a greyed-out tab or button says when a demo organisation clicks it.
 * The page underneath stays where it was: the demo is there to practise.
 */
export function DemoUnavailableDialog() {
  const open = useDemoUnavailableOpen();

  return (
    <Dialog open={open} onOpenChange={(next) => !next && hideDemoUnavailable()}>
      <DialogContent size='md'>
        <EmptyState
          className='py-8'
          icon={<Lock />}
          title={
            <DialogTitle render={<span />}>{m.demo_unavailable_title()}</DialogTitle>
          }
          description={
            <DialogDescription render={<span />}>
              {m.demo_unavailable_description()}
            </DialogDescription>
          }
          action={
            <Button onClick={hideDemoUnavailable}>{m.demo_unavailable_close()}</Button>
          }
        />
      </DialogContent>
    </Dialog>
  );
}
